<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.51704 12.9406C3.76112 13.1847 4.15685 13.1847 4.40093 12.9406L10.0007 7.34091L15.6004 12.9406C15.8445 13.1847 16.2402 13.1847 16.4843 12.9406C16.7283 12.6966 16.7283 12.3008 16.4843 12.0568L10.4426 6.01509C10.1985 5.77101 9.80279 5.77101 9.55871 6.01509L3.51704 12.0568C3.27296 12.3008 3.27296 12.6966 3.51704 12.9406Z" fill="white" style="fill:white;fill-opacity:1;" />
  </svg>
</template>
